import _ from 'lodash';
import React from 'react';
import literals from './literals';
import { BUDGETS_APP_NAME, PRODUCT_NAME } from 'src/utils/constants';

export default class LiteralsService {
    public static getAppName(): string {
        return PRODUCT_NAME;
    }

    public static replaceAppName(appName: string): string {
        switch (appName) {
            case '$APP_NAME':
                return PRODUCT_NAME;
            case '$BUDGETS_APP_NAME':
                return BUDGETS_APP_NAME;
        }
    }

    public static getLabels(key: string): { [name: string]: string } {
        return _.get(literals, key);
    }

    // you can do args
    // "stepNumber": "${args[0]} of BodesWell's 7 Steps to Financial Independence is now available"
    public static getLiteral(key: string, args?: any[]): string {
        // replaces $APP_NAME with the app name
        const literal: any = _.get(literals, key)
            ?.replaceAll('$APP_NAME', this.replaceAppName('$APP_NAME'))
            .replaceAll('$BUDGETS_APP_NAME', this.replaceAppName('$BUDGETS_APP_NAME'));
        if (!args) return literal;
        // eslint-disable-next-line
        return eval('`' + literal + '`');
    }

    public static getJsxLiteral(key: string, args?: any[]): JSX.Element {
        const literal: string = this.getLiteral(key, args);
        if (!literal) return null;
        const jsx: JSX.Element = <span dangerouslySetInnerHTML={{ __html: literal }}></span>;
        return jsx;
    }
}
